module.exports = __webpack_public_path__ + "static/media/question.c04b0d8f.svg";